import classNames from "classnames";
import { useOutletContext } from "react-router-dom";

interface SectionHeadingProps {
  heading: string;
}

export default function SectionHeading({ heading }: SectionHeadingProps) {
  const { whiteLabelStyle } = useOutletContext() as any;

  return (
    <h3
      className={classNames(
        "text-sm text-gray-700 font-medium w-max border-b-2  py-2 my-4 text-center",
        whiteLabelStyle?.theme?.color?.border || "border-indigo-500"
      )}
    >
      {heading}
    </h3>
  );
}
